/* eslint-disable react/no-array-index-key */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import {
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  Input,
} from "@repo/ui";
import { useEffect, useMemo, useState } from "react";
import {
  CheckIcon,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  CrossIcon,
  Info,
  RefreshCcw,
  Settings,
  XIcon,
} from "lucide-react";
import {
  useGetAvailableColumns,
  useGetUserColumns,
  useGetUserSettings,
  useUpdateUserColumns,
  useUpdateUserSettings,
} from "services/dynamic-filtering";
import eventBus from "store/event-emitter";
import Loader from "ui/page-loader";
import { DEFAULT_CCA_COLUMNS } from "./constants";
import { useUser } from "hooks/use-user";
import { isCallCenterAgent } from "pages/tickets/utils";

export default function ColumnsSettings({ ticketsType = "allcalls" }) {
  const {
    mutate: getAvailableColumns,
    data: availableColumnsRes,
    isPending: gettingAvailableColumns,
    reset: resetAvailableColumns,
  } = useGetAvailableColumns();
  const {
    mutate: getUserColumns,
    data: userColumnsRes,
    isPending: gettingUserColumns,
    reset: resetUserColumns,
  } = useGetUserColumns();
  const {
    mutate: updateUserColumns,
    data: updateColumnsRes,
    isPending: updatingUserColumns,
    reset: resetUpdateColumns,
  } = useUpdateUserColumns();
  const {
    mutate: getUserSettings,
    data: userSettingsRes,
    isPending: gettingUserSettings,
    reset: resetUserSettings,
  } = useGetUserSettings();

  const {
    mutate: updateUserSettings,
    data: updateUserSettingsRes,
    isPending: updatingUserSettings,

    reset: resetUpdateUserSettings,
  } = useUpdateUserSettings();
  const [isOpen, setIsOpen] = useState(false);
  const [availableColumns, setAvailableColumns] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [savedAvailableColumns, setSavedAvailableColumns] = useState([]);
  const [savedSelectedColumns, setSavedSelectedColumns] = useState([]);
  const [availableColumnsSelected, setAvailableColumnsSelected] = useState([]);
  const [userColumnsSelected, setUserColumnsSelected] = useState([]);
  const [userSettings, setUserSettings] = useState({});
  const [filteredAvailableColumn, setFilteredAvailableColumn] = useState("");
  const [filteredSelectedColumn, setFilteredSelectedColumn] = useState("");
  // const [scrollSelectedDiv, setScrollSelectedDiv] = useState(null);
  // const [scrollAvailableDiv, setScrollAvailableDiv] = useState(null);
  const user = useUser();
  const isCca = isCallCenterAgent(user);
  useEffect(() => {
    getAvailableColumns(ticketsType);
    getUserColumns(ticketsType);
    getUserSettings(ticketsType);
  }, []);
  useEffect(() => {
    if (availableColumnsRes && userColumnsRes) {
      setSavedAvailableColumns({ ...availableColumnsRes.data });
      setSavedSelectedColumns({ ...userColumnsRes.data });
      setAvailableColumns(
        availableColumnsRes.data.columns.filter((elm) => {
          if (
            userColumnsRes.data.columns.find(
              (item) => item.columnId === elm.columnId,
            )
          ) {
            return false;
          }
          return true;
        }),
      );
      setSelectedColumns(
        userColumnsRes.data.columns.sort((a, b) => {
          if (a.order < b.order) {
            return 1;
          }
          return 0;
        }),
      );
      resetUserColumns();
      resetAvailableColumns();
    } else if (availableColumnsRes) {
      setAvailableColumns(availableColumnsRes.data.columns);
      setSavedAvailableColumns({ ...availableColumnsRes.data });
    }

    if (updateColumnsRes && updateUserSettingsRes) {
      getAvailableColumns(ticketsType);
      getUserColumns(ticketsType);
      getUserSettings(ticketsType);
      eventBus.emit("updateColumns", {});
      resetUpdateColumns();
      resetUpdateUserSettings();
      setIsOpen(false);
    }
    if (userSettingsRes) {
      setUserSettings(userSettingsRes.data);
      resetUserSettings();
    }
  }, [
    availableColumnsRes,
    userColumnsRes,
    updateColumnsRes,
    userSettingsRes,
    updateUserSettingsRes,
  ]);

  const saveUserColumns = () => {
    const _userColumns = Array.from(
      new Map(selectedColumns.map((item) => [item.columnId, item])).values(),
    );

    updateUserColumns({
      screen: ticketsType,
      columns: _userColumns.map((elm, index) => ({
        columnId: elm.columnId,
        visible: true,
        label: elm.label,
        order: index + 1,
      })),
    });
    updateUserSettings({ ...userSettings, screen: ticketsType });
  };
  const resetColumns = () => {
    const _selectedColumns = [];
    const _availableColumns = [];
    const defaultColumns = isCca ? DEFAULT_CCA_COLUMNS : DEFAULT_CCA_COLUMNS;
    savedAvailableColumns?.columns.forEach((elm) => {
      if (defaultColumns.includes(elm.columnId)) {
        _selectedColumns.push(elm);
      } else {
        _availableColumns.push(elm);
      }
    });
    _selectedColumns.sort((a, b) => a.order - b.order);
    _availableColumns.sort((a, b) => a.order - b.order);
    setSelectedColumns(_selectedColumns);
    setAvailableColumns(_availableColumns);
  };
  const onSelectAllToggle = (isSelected) => {
    if (isSelected) {
      setSelectedColumns([...(savedAvailableColumns?.columns || [])]);
      setAvailableColumns([]);
    } else {
      setAvailableColumns([...(savedAvailableColumns?.columns || [])]);
      setSelectedColumns([]);
    }
  };
  const addColumns = (columnId = null) => {
    if (columnId === null && availableColumnsSelected.length === 0) {
      return;
    }

    let _availableColumns = [...availableColumns];
    const _selectedColumns = [...selectedColumns];
    if (columnId !== null) {
      const currentCol = availableColumns.find(
        (elm) => elm.columnId === columnId,
      );
      if (!_selectedColumns.find((elm) => elm.columnId === columnId)) {
        _selectedColumns.push(currentCol);
        _availableColumns = _availableColumns.filter(
          (elm) => elm.columnId !== currentCol.columnId,
        );
      }
    }
    availableColumnsSelected.forEach((Id) => {
      const currentCol = availableColumns.find((elm) => elm.columnId === Id);
      if (!_selectedColumns.find((elm) => elm.columnId === columnId)) {
        _selectedColumns.push(currentCol);
        _availableColumns = _availableColumns.filter(
          (elm) => elm.columnId !== currentCol.columnId,
        );
      }
    });
    _selectedColumns.sort((a, b) => a.order - b.order);
    _availableColumns.sort((a, b) => a.order - b.order);
    setSelectedColumns(_selectedColumns);
    setAvailableColumnsSelected([]);
    setAvailableColumns([..._availableColumns]);

    if (document.getElementById("selected-div")) {
      document.getElementById("selected-div").scrollTop =
        document.getElementById("selected-div").scrollHeight;
    }
  };
  const removeColumns = (columnId = null) => {
    if (columnId === null && userColumnsSelected.length === 0) {
      return;
    }
    const _availableColumns = [...availableColumns];
    let _selectedColumns = [...selectedColumns];
    if (columnId !== null) {
      const currentCol = selectedColumns.find(
        (elm) => elm.columnId === columnId,
      );
      if (!_availableColumns.find((elm) => elm.columnId === columnId)) {
        _availableColumns.push(currentCol);
        _selectedColumns = _selectedColumns.filter(
          (elm) => elm.columnId !== currentCol.columnId,
        );
      }
    }
    userColumnsSelected.forEach((Id) => {
      const currentCol = selectedColumns.find((elm) => elm.columnId === Id);
      if (!_availableColumns.find((elm) => elm.columnId === columnId)) {
        _availableColumns.push(currentCol);
        _selectedColumns = _selectedColumns.filter(
          (elm) => elm.columnId !== currentCol.columnId,
        );
      }
    });

    _selectedColumns.sort((a, b) => a.order - b.order);

    _availableColumns.sort((a, b) => a.order - b.order);
    setSelectedColumns(_selectedColumns);
    setUserColumnsSelected([]);
    setAvailableColumns([..._availableColumns]);

    if (document.getElementById("selected-div")) {
      document.getElementById("selected-div").scrollTop =
        document.getElementById("selected-div").scrollHeight;
    }
  };
  const moveColumnUp = () => {
    if (userColumnsSelected.length === 0) {
      return;
    }
    let isChangeValid = true;
    const _selectedColumns = [...selectedColumns];
    const columnsIndex = [];
    userColumnsSelected.forEach((elm) => {
      const currentColIndex = _selectedColumns.findIndex(
        (col) => col.columnId === elm,
      );
      if (currentColIndex === 0) {
        isChangeValid = false;
      }
      columnsIndex.push(currentColIndex);
    });
    if (!isChangeValid) {
      return;
    }
    columnsIndex.sort((a, b) => {
      if (a < b) {
        return 1;
      }
      return 0;
    });
    columnsIndex.forEach((i) => {
      const currentColIndex = i;
      const currentCol = JSON.parse(
        JSON.stringify(_selectedColumns[currentColIndex]),
      );
      const prevCol = JSON.parse(
        JSON.stringify(_selectedColumns[currentColIndex - 1]),
      );
      _selectedColumns[currentColIndex] = prevCol;
      _selectedColumns[currentColIndex - 1] = currentCol;
    });

    setSelectedColumns(_selectedColumns);
  };
  const moveColumnDown = () => {
    if (userColumnsSelected.length === 0) {
      return;
    }
    let isChangeValid = true;
    const _selectedColumns = [...selectedColumns];
    const columnsIndex = [];
    userColumnsSelected.forEach((elm) => {
      const currentColIndex = _selectedColumns.findIndex(
        (col) => col.columnId === elm,
      );
      if (currentColIndex === selectedColumns.length - 1) {
        isChangeValid = false;
      }
      columnsIndex.push(currentColIndex);
    });
    if (!isChangeValid) {
      return;
    }
    columnsIndex.sort((a, b) => {
      if (a < b) {
        return 1;
      }
      return 0;
    });
    while (columnsIndex.length > 0) {
      const currentColIndex = columnsIndex.pop();
      const currentCol = JSON.parse(
        JSON.stringify(_selectedColumns[currentColIndex]),
      );
      const nextCol = JSON.parse(
        JSON.stringify(_selectedColumns[currentColIndex + 1]),
      );
      _selectedColumns[currentColIndex] = nextCol;
      _selectedColumns[currentColIndex + 1] = currentCol;
    }

    setSelectedColumns(_selectedColumns);
  };
  const availableColumnsList = useMemo(() => {
    return availableColumns.filter((elm) =>
      elm.label.toLowerCase().includes(filteredAvailableColumn.toLowerCase()),
    );
  }, [filteredAvailableColumn, availableColumns]);
  const selectedColumnsList = useMemo(() => {
    return selectedColumns.filter((elm) =>
      elm.label.toLowerCase().includes(filteredSelectedColumn.toLowerCase()),
    );
  }, [filteredSelectedColumn, selectedColumns]);
  return (
    <>
      {gettingAvailableColumns ||
      gettingUserColumns ||
      updatingUserColumns ||
      gettingUserSettings ||
      updatingUserSettings ? (
        <Loader />
      ) : null}
      <Dialog
        open={isOpen}
        onOpenChange={(e) => {
          setIsOpen(e);
        }}
      >
        <DialogTrigger asChild>
          <Button variant="secondary" className="w-max" title="Column Settings">
            <Settings />
          </Button>
        </DialogTrigger>
        <DialogContent className="max-w-[80vw] max-h-[90vh] h-[90vh] flex flex-col gap-2 overflow-y-scroll">
          <DialogHeader>
            <DialogTitle className="mb-8">Column Settings</DialogTitle>
          </DialogHeader>
          <div className="flex flex-col gap-2 w-full ">
            <div className="flex flex-row gap-2 items-end justify-end">
              <Button onClick={saveUserColumns} variant="secondary">
                Save
              </Button>
            </div>
            <div className="flex flex-row items-center">
              Columns marked with&nbsp;
              <Info width="12px" height="12px" color="red" /> &nbsp;may increase
              page loading time. Selecting multiple such columns can slow down
              the grid display
            </div>

            <div className="flex flex-row gap-2 items-center h-[500px] w-full">
              <div className="flex flex-col gap-3 h-full w-full">
                <h2 className="font-medium">Available Columns</h2>

                <div className=" h-full overflow-y-scroll border border-secondary  flex flex-col rounded-sm">
                  <div className="w-full flex flex-row gap-2 p-2">
                    <Input
                      className="w-full"
                      placeholder="Search"
                      value={filteredAvailableColumn}
                      onChange={(e) => {
                        setFilteredAvailableColumn(e.target.value);
                      }}
                    />
                    <Button
                      variant="secondary"
                      onClick={() => {
                        setFilteredAvailableColumn("");
                      }}
                    >
                      <RefreshCcw color="white" />
                    </Button>
                    <Button
                      className="pl-[0.5rem] pr-[0.5rem]"
                      title="Select All"
                      onClick={() => {
                        setAvailableColumnsSelected(
                          availableColumnsList.map((elm) => elm.columnId),
                        );
                      }}
                      variant="secondary"
                    >
                      <CheckIcon color="white" />
                    </Button>
                    <Button
                      className="pl-[0.5rem] pr-[0.5rem]"
                      title="Un Select All"
                      onClick={() => {
                        setAvailableColumnsSelected([]);
                      }}
                      variant="secondary"
                    >
                      <XIcon color="white" />
                    </Button>
                  </div>

                  {availableColumnsList.map((column, index) => (
                    <div
                      key={`selected-${index}`}
                      id={`selected-${index}`}
                      className={`p-2 cursor-pointer ${availableColumnsSelected.includes(column.columnId) ? "bg-blue-300" : "hover:bg-gray-200"}`}
                      onClick={() => {
                        if (
                          availableColumnsSelected.includes(column.columnId)
                        ) {
                          setAvailableColumnsSelected([
                            ...availableColumnsSelected.filter(
                              (elm) => elm !== column.columnId,
                            ),
                          ]);
                        } else {
                          setAvailableColumnsSelected([
                            ...availableColumnsSelected,
                            column.columnId,
                          ]);
                        }
                      }}
                      onDoubleClick={() => {
                        addColumns(column.columnId);
                      }}
                    >
                      <div className="flex flex-row gap-2 items-center">
                        {column.label}
                        <div
                          className="w-4 h-4"
                          title="This Column may increase page loading time. Selecting multiple such columns can slow down the grid display"
                        >
                          {column.isComputed ? (
                            <Info width="12px" height="12px" color="red" />
                          ) : null}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="flex flex-col gap-1">
                <Button
                  variant="outline"
                  className="border-secondary"
                  disabled={!availableColumnsSelected.length}
                  onClick={() => {
                    addColumns();
                  }}
                >
                  <ChevronRight color="#000000" />
                </Button>
                <Button
                  variant="outline"
                  className="border-secondary"
                  disabled={!userColumnsSelected.length}
                  onClick={() => {
                    removeColumns();
                  }}
                >
                  <ChevronLeft color="#000000" />
                </Button>
              </div>
              <div className="flex flex-col gap-3 h-[500px] w-full">
                <h2 className="font-medium">Selected Columns</h2>
                <div
                  className=" h-full overflow-y-scroll border border-secondary  flex flex-col rounded-sm"
                  id="selected-div"
                >
                  <div className="w-full flex flex-row gap-2 p-2">
                    <Input
                      className="w-full"
                      placeholder="Search"
                      value={filteredSelectedColumn}
                      onChange={(e) => {
                        setFilteredSelectedColumn(e.target.value);
                      }}
                    />
                    <Button
                      variant="secondary"
                      onClick={() => {
                        setFilteredSelectedColumn("");
                      }}
                    >
                      <RefreshCcw color="white" />
                    </Button>
                    <Button
                      className="pl-[0.5rem] pr-[0.5rem]"
                      title="Select All"
                      onClick={() => {
                        setUserColumnsSelected(
                          selectedColumnsList.map((elm) => elm.columnId),
                        );
                      }}
                      variant="secondary"
                    >
                      <CheckIcon color="white" />
                    </Button>
                    <Button
                      className="pl-[0.5rem] pr-[0.5rem]"
                      title="Un Select All"
                      onClick={() => {
                        setUserColumnsSelected([]);
                      }}
                      variant="secondary"
                    >
                      <XIcon color="white" />
                    </Button>
                  </div>
                  {selectedColumnsList.map((column, index) => (
                    <div
                      key={`selected-${index}`}
                      id={`selected-${index}`}
                      className={`p-2 cursor-pointer ${userColumnsSelected.includes(column.columnId) ? "bg-blue-300" : "hover:bg-gray-200"}`}
                      onClick={() => {
                        if (userColumnsSelected.includes(column.columnId)) {
                          setUserColumnsSelected([
                            ...userColumnsSelected.filter(
                              (elm) => elm !== column.columnId,
                            ),
                          ]);
                        } else {
                          setUserColumnsSelected([
                            ...userColumnsSelected,
                            column.columnId,
                          ]);
                        }
                      }}
                      onDoubleClick={() => {
                        removeColumns(column.columnId);
                      }}
                    >
                      {column.label}
                    </div>
                  ))}
                </div>
              </div>
              <div className="flex flex-col gap-1">
                <Button variant="outline" onClick={moveColumnUp}>
                  <ChevronUp color="#000000" className="border-secondary" />
                </Button>
                <Button variant="outline" onClick={moveColumnDown}>
                  <ChevronDown color="#000000" className="border-secondary" />
                </Button>
              </div>
            </div>
            <div className="flex flex-row flex-wrap gap-4">
              <div className="flex flex-row gap-1 items-center">
                <Checkbox
                  id="activeRowHighlighting"
                  onCheckedChange={() => {
                    setUserSettings({
                      ...userSettings,
                      activeRowHighlighting:
                        !userSettings?.activeRowHighlighting,
                    });
                  }}
                  checked={userSettings?.activeRowHighlighting || false}
                />
                <p htmlFor="activeRowHighlighting">Active Row High Lighting</p>
              </div>
              <div className="flex flex-row gap-1 items-center">
                <Checkbox
                  id="compactRows"
                  checked={userSettings?.compactRows || false}
                  onCheckedChange={() => {
                    setUserSettings({
                      ...userSettings,
                      compactRows: !userSettings?.compactRows,
                    });
                  }}
                />
                <p htmlFor="compactRows">Compact Rows</p>
              </div>
              {/* <div className="flex flex-row gap-1 items-center">
                <Checkbox
                  id="doubleClickToEdit"
                  checked={userSettings?.doubleClickToEdit || false}
                  onCheckedChange={() => {
                    setUserSettings({
                      ...userSettings,
                      doubleClickToEdit: !userSettings?.doubleClickToEdit,
                    });
                  }}
                />
                <p htmlFor="doubleClickToEdit">Double Click To Edit</p>
              </div> */}
              {/* <div className="flex flex-row gap-1 items-center">
                <Checkbox
                  id="enableListEdit"
                  checked={userSettings?.enableListEdit || false}
                  onCheckedChange={() => {
                    setUserSettings({
                      ...userSettings,
                      enableListEdit: !userSettings?.enableListEdit,
                    });
                  }}
                />
                <p htmlFor="enableListEdit">Enable List Edit</p>
              </div> */}
              {/* <div className="flex flex-row gap-1 items-center">
                <Checkbox
                  id="modernCellColoring"
                  checked={userSettings?.modernCellColoring || false}
                  onCheckedChange={() => {
                    setUserSettings({
                      ...userSettings,
                      modernCellColoring: !userSettings?.modernCellColoring,
                    });
                  }}
                />
                <p htmlFor="modernCellColoring">Modern Cell Coloring</p>
              </div> */}
              <div className="flex flex-row gap-1 items-center">
                <Checkbox
                  id="wrapColumnText"
                  checked={userSettings?.wrapColumnText || false}
                  onCheckedChange={() => {
                    setUserSettings({
                      ...userSettings,
                      wrapColumnText: !userSettings?.wrapColumnText,
                    });
                  }}
                />
                <p htmlFor="wrapColumnText">Wrap Column Text</p>
              </div>
            </div>
            <div>
              <Button
                variant="outline"
                onClick={() => {
                  resetColumns();
                }}
              >
                Reset To Default
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
